import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';

import { XIQ_ONLINE_URL } from 'constants/index';
import { getCSRFToken, setRedirectionPath } from 'utils';

import { Freshchat } from 'reactjs-freshchat';
import WbGilroy from 'components/wb-gilroy';

export const PrivateRoute = (props: any) => {
  const [hostName] = useState(window.location.hostname);
  const [cookies] = useCookies();
  const isLogout = cookies?.isLogout;
  const csrfToken = getCSRFToken();

  useEffect(() => {
    // Redirect logic
    if (isLogout && isLogout !== '1' && csrfToken) {
      return;
    } else if (hostName !== 'localhost') {
      setRedirectionPath();
      window.location.href = `${XIQ_ONLINE_URL}auth/login?redirectURL=${window.location.origin}`;
    }
  }, [isLogout, csrfToken, hostName]);

  if (isLogout && isLogout !== '1' && csrfToken) {
    return (
      <>
        <WbGilroy />
        <Freshchat
          token={'1f9215d1-96af-4a4d-9634-cecb117ff337'}
          host={'https://wchat.freshchat.com'}
          externalId={localStorage.getItem('email') || ''}
          email={localStorage.getItem('email') || ''}
          firstName={localStorage.getItem('fullname') || ''}
          faqTags={{
            tags: ['Workbench'],
            filterType: 'category',
          }}
        />
        {props.children}
      </>
    );
  }

  return <Navigate to={'/'} />;
};
